import { AGENT_API } from '../AgentAPI';
export function createCommonService(api) {
    return {
        getGames() {
            return api.fetch(AGENT_API.GET_GAMES);
        },
        getActivities() {
            return api.fetch(AGENT_API.GET_ACTIVITY_TYPES);
        },
        getAccountSearch(data) {
            return api.fetch(AGENT_API.GET_ACCOUNT_SEARCH, { data });
        },
        uploadImage(file) {
            const formData = new FormData();
            formData.append('file', file);
            return api.fetch(AGENT_API.POST_IMAGE, { data: formData });
        }
    };
}
//# sourceMappingURL=CommonService.js.map